/**
 * Mirrors `WhereDTO` from packages/core/src/dto.ts (#470). Kept local so the web app builds before
 * that type reaches main; switch to `import type { WhereDTO } from "@roomate/core"` once it lands.
 */
export type WhereInfo =
  | { role: "hub"; hub: { name: string } }
  | { role: "node"; hub: { name: string }; node: { id: string; name: string; owner: string; sameMachineAsHub: boolean } };

export interface WhereLabel {
  /** Below the `sm` breakpoint the chip shows only this. */
  short: "Hub" | "Node";
  text: string;
  title: string;
  /** Pill tones from calm.tsx. Hub and node must differ. */
  tone: "signal" | "neutral";
}

export function whereLabel(dto: WhereInfo): WhereLabel {
  if (dto.role === "hub") {
    return {
      short: "Hub",
      text: `Hub · ${dto.hub.name}`,
      title: "You're on the main hub. It holds the team's data.",
      tone: "signal",
    };
  }
  const { node, hub } = dto;
  if (node.sameMachineAsHub) {
    return {
      short: "Hub",
      text: `Hub · ${hub.name}`,
      title: `You're on the hub machine, through ${node.owner}'s node ${node.name}.`,
      tone: "signal",
    };
  }
  return {
    short: "Node",
    text: `${node.owner}'s node · ${node.name}`,
    title: `You're on a team member's node. It relays to the hub ${hub.name}.`,
    tone: "neutral",
  };
}
